<template>
  <div>
    <b-card border-variant="danger" v-if="errore_caricamento">
      <b-row class="match-height">
        <b-col
          md="8"
        >
          <h4 class="mt-0 mb-0 text-danger">Errore durante il caricamento delle informazioni iniziali</h4>
          <p>Ti preghiamo di segnalare il problema all'assistenza tecnica, grazie</p>
        </b-col>
        <b-col 
          md="4"
          class="text-center"
        >
          <b-button
          variant="primary"
          :to="{ name: 'crm-customer-index' }"
          >
              <feather-icon
                  icon="CornerUpLeftIcon"
                  size="16"
                  class="mr-1"
              />Torna ai Clienti
          </b-button>
        </b-col>
      </b-row>
        
    </b-card>
    
    <div class="text-center my-3" v-if="Caricato == false">
        <b-spinner
            variant="primary"
            style="width: 3rem; height: 3rem;"
            class="mr-1"
            label="loading"
        />
    </div>

    <div v-if="Caricato">
      <validation-observer ref="simpleRules">
        <b-form>
          <b-tabs pills>
            <b-tab active>
              <template #title>
                <feather-icon
                  icon="UserIcon"
                  size="16"
                  class="mr-0 mr-lg-50"
                />
                <span class="d-none d-lg-inline">Dettagli</span>
              </template>
              <b-card bg-variant="Default">
                <b-row>
                  <b-col md="4" lg="3">
                    <b-form-group label="Ragione Sociale *" label-for="company_name">
                        <validation-provider
                        #default="{ errors }"
                        name="Ragione Sociale"
                        rules="required"
                        >
                        <b-form-input
                          v-model="campiform.billing.company_name"
                          placeholder=""
                        />
                        <small class="text-danger">{{ errors[0] }}</small>
                        </validation-provider>
                    </b-form-group>
                  </b-col>
                  <b-col md="4" lg="3">
                    <b-form-group label="Nome *" label-for="name">
                        <validation-provider
                        #default="{ errors }"
                        name="Nome"
                        rules="required"
                        >
                        <b-form-input
                            v-model="campiform.user.name"
                            placeholder=""
                        />
                        <small class="text-danger">{{ errors[0] }}</small>
                        </validation-provider>
                    </b-form-group>
                  </b-col>
                  <b-col md="4" lg="3">
                    <b-form-group label="Cognome *" label-for="Surname">
                        <validation-provider
                        #default="{ errors }"
                        name="Cognome"
                        rules="required"
                        >
                        <b-form-input
                            v-model="campiform.user.surname"
                            :state="errors.length > 0 ? false:null"
                            placeholder=""
                        />
                        <small class="text-danger">{{ errors[0] }}</small>
                        </validation-provider>
                    </b-form-group>
                  </b-col>
                  <b-col md="4" lg="3">
                    <b-form-group label="Email *" label-for="email">
                        <validation-provider
                        #default="{ errors }"
                        name="Email dell'utente"
                        rules="required|email"
                        >
                        <b-form-input
                            v-model="campiform.user.email"
                            :state="errors.length > 0 ? false:null"
                            placeholder=""
                        />
                        <small class="text-danger">{{ errors[0] }}</small>
                        </validation-provider>
                    </b-form-group>
                  </b-col>
                  <b-col md="4" lg="3">
                    <b-form-group label="Cellulare *" label-for="Cellulare">
                        <validation-provider
                        #default="{ errors }"
                        name="Cellulare"
                        rules="required"
                        >
                        <b-form-input
                            v-model="campiform.user.mobile_phone"
                            placeholder=""
                        />
                        <small class="text-danger">{{ errors[0] }}</small>
                        </validation-provider>
                    </b-form-group>
                  </b-col>
                  <b-col md="4" lg="3">
                    <b-form-group label="Telefono" label-for="telefono">
                        <b-form-input
                            v-model="campiform.user.phone"
                            placeholder=""
                        />
                    </b-form-group>
                  </b-col>
                  <b-col md="4" lg="3">
                    <b-form-group label="Reseller *" label-for="reseller_id">
                      <b-form-select
                        v-model="campiform.customer.reseller_id"
                        :options="options_usercrm_reseller"
                      />
                    </b-form-group>
                  </b-col>
                  <b-col md="4" lg="3">
                    <b-form-group label="Assistente *" label-for="assistant_id">
                      <b-form-select
                        v-model="campiform.customer.assistant_id"
                        :options="options_usercrm_assistente"
                      />
                    </b-form-group>
                  </b-col>
                  <b-col md="4" lg="3">
                    <b-form-group label="Valutazione *" label-for="evaluation_id">
                      <validation-provider
                      #default="{ errors }"
                      name="Valutazione"
                      rules="required"
                      >
                      <b-form-select
                        v-model="campiform.customer.evaluation_id"
                        :options="options_evalution"
                      />
                      <small class="text-danger">{{ errors[0] }}</small>
                      </validation-provider>
                    </b-form-group>
                  </b-col>
                  <b-col md="4" lg="3">
                    <b-form-group label="Rating" label-for="rating">
                        <b-form-select
                            v-model="campiform.customer.rating"
                            :options="options_rating"
                        />
                    </b-form-group>
                  </b-col>
                  <b-col md="4" lg="3">
                    <b-form-group label="Stato *" label-for="status_id">
                      <validation-provider
                      #default="{ errors }"
                      name="Stato"
                      rules="required"
                      >
                      <b-form-select
                        v-model="campiform.customer.status_id"
                        :options="options_status"
                      />
                      <small class="text-danger">{{ errors[0] }}</small>
                      </validation-provider>
                    </b-form-group>
                  </b-col>
                  <b-col md="4" lg="3">
                    <b-form-group label="Iscritto newsletter *" label-for="newsletter">
                        <b-form-select
                            v-model="campiform.user.newsletter"
                            :options="options_newsletter"
                        />
                    </b-form-group>
                  </b-col>
                  <b-col md="4" lg="6">
                    <b-form-group label="Sito web" label-for="website">
                        <b-form-input
                            v-model="campiform.user.website"
                            placeholder=""
                        />
                    </b-form-group>
                  </b-col>
                </b-row>

              </b-card>
            </b-tab>

            <b-tab>
              <template #title>
                <feather-icon
                  icon="LockIcon"
                  size="16"
                  class="mr-0 mr-lg-50"
                />
                <span class="d-none d-lg-inline">Fatturazione</span>
              </template>
              <b-card bg-variant="Default">
                <b-row>
                  <b-col md="4" lg="3">
                    <b-form-group label="Nazione *" label-for="country_id">
                      <validation-provider
                      #default="{ errors }"
                      name="Nazione"
                      rules="required"
                      >
                        <vue-autosuggest
                          ref="autocomplete"
                          v-model="valoreDefaultNazione"
                          :suggestions="filteredOptions"
                          :limit="8"
                          :input-props="{id:'autosuggest__input',class:'form-control', placeholder:'cerca nazione', }"
                          :render-suggestion="renderSuggestion"
                          :get-suggestion-value="getSuggestionValue"
                          @input="onInputChange"
                          @selected="selectHandler"
                        >
                          <template slot-scope="{suggestion}">
                            <span class="my-suggestion-item">{{ suggestion.item.name }}</span>
                          </template>
                        </vue-autosuggest>
                        <small class="text-danger">{{ errors[0] }}</small>
                      </validation-provider>
                    </b-form-group>
                  </b-col>
                  <b-col md="4" lg="3">
                    <b-form-group label="Indirizzo *" label-for="address">
                      <validation-provider
                      #default="{ errors }"
                      name="Indirizzo"
                      rules="required|min:2"
                      >
                        <b-form-input
                            v-model="campiform.billing.address"
                            placeholder=""
                            :state="errors.length > 0 ? false:null"
                        />
                        <small class="text-danger">{{ errors[0] }}</small>
                      </validation-provider>
                    </b-form-group>
                  </b-col>
                  <b-col md="4" lg="3">
                    <b-form-group label="Cap *" label-for="zip">
                      <validation-provider
                      #default="{ errors }"
                      name="Cap"
                      :rules="lunghezza_campo_cap"
                      >
                      <b-form-input
                          v-model="campiform.billing.zip"
                          :state="errors.length > 0 ? false:null"
                          placeholder=""
                      />
                      <small class="text-danger">{{ errors[0] }}</small>
                      </validation-provider>
                    </b-form-group>
                  </b-col>
                  <b-col md="4" lg="3">
                    <b-form-group label="Città *" label-for="city">
                      <validation-provider
                      #default="{ errors }"
                      name="Città"
                      rules="required|min:2"
                      >
                        <b-form-input
                            v-model="campiform.billing.city"
                            placeholder=""
                        />
                        <small class="text-danger">{{ errors[0] }}</small>
                      </validation-provider>
                    </b-form-group>
                  </b-col>
                  <b-col md="4" lg="3">
                    <div v-if="campiform.billing.province_id == 112">
                      <b-form-group label="Provincia *" label-for="province_foreign">
                        <validation-provider
                        #default="{ errors }"
                        name="Provincia"
                        rules="required|min:2"
                        >
                          <b-form-input
                              v-model="campiform.billing.province_foreign"
                              placeholder=""
                              rules="min:2"
                          />
                        <small class="text-danger">{{ errors[0] }}</small>
                        </validation-provider>
                      </b-form-group>
                    </div>
                    <div v-else>
                      <b-form-group label="Provincia *" label-for="province_id">
                        <validation-provider
                          #default="{ errors }"
                          name="Provincia"
                          rules="required"
                          >
                          <b-form-select
                            v-model="campiform.billing.province_id"
                            :state="errors.length > 0 ? false:null"
                            :options="options_province"
                          />
                        <small class="text-danger">{{ errors[0] }}</small>
                        </validation-provider>
                      </b-form-group>
                    </div>
                  </b-col>
                  <b-col md="4" lg="3">
                    <b-form-group label="Partita IVA *" label-for="vat_number">
                      <validation-provider
                      #default="{ errors }"
                      name="Partita IVA"
                      rules="regex:^([a-zA-Z0-9]+)$|min:5"
                      >
                        <b-form-input
                          v-model="campiform.billing.vat_number"
                          :state="errors.length > 0 ? false:null"
                          placeholder=""
                        />
                        <small class="text-danger">{{ errors[0] }}</small>
                      </validation-provider>
                    </b-form-group>
                  </b-col>
                  <b-col md="4" lg="3">
                    <b-form-group label="Codice fiscale" label-for="fiscal_code">
                      <b-form-input
                        v-model="campiform.billing.fiscal_code"
                        placeholder=""
                        :readonly="isReadOnly_fiscal_code"
                      />
                    </b-form-group>
                  </b-col>
                  <b-col md="4" lg="3">
                    <b-form-group label="Pec" label-for="pec">
                      <b-form-input
                        v-model="campiform.billing.pec"
                        placeholder=""
                        :readonly="isReadOnly_pec"
                      />
                    </b-form-group>
                  </b-col>
                  <b-col md="4" lg="3">
                    <b-form-group label="Codice SDI" label-for="dest_code">
                      <validation-provider
                      #default="{ errors }"
                      name="Codice SDI"
                      rules="length:7"
                      >
                        <b-form-input
                          v-model="campiform.billing.dest_code"
                          :state="errors.length > 0 ? false:null"
                          placeholder=""
                          :readonly="isReadOnly_dest_code"
                        />
                      </validation-provider>
                    </b-form-group>
                  </b-col>
                  <b-col md="4" lg="3">
                    <b-form-group label="Regime IVA" label-for="vat_scheme_id">
                      <b-form-select
                        v-model="campiform.billing.vat_scheme_id"
                        :options="options_regine_iva"
                      />
                    </b-form-group>
                  </b-col>
                  <b-col md="8" lg="6">
                    <b-form-group
                      label="Pagamenti"
                      label-for="v-adse-pagamenti"
                    >
                      <multiselect
                        v-model="campiform.payment.list"
                        :options="options_payment"
                        :custom-label="multiSelect_act_Lingua" 
                        placeholder="seleziona o ricerca"
                        :multiple="true"
                        :close-on-select="false" 
                        :clear-on-select="false"
                        :preserve-search="true"
                        :show-labels="false"
                        :max-height="250"
                        :max="5"
                        label="pagamenti" 
                        track-by="text" 
                      >
                        <span slot="noResult">Nessun risultato</span>
                        <span slot="maxElements">Limite opzioni selezionabili raggiunto</span>
                      </multiselect>
                    </b-form-group>
                  </b-col>
                  <b-col md="4" lg="3">
                    <b-form-group label="Split Payment" label-for="split_payment">
                        <b-form-select
                            v-model="campiform.billing.split_payment"
                            :options="options_split_payment"
                        />
                    </b-form-group>
                  </b-col>
                  <b-col md="8" lg="6">
                    <label for="textarea-note">Note XML</label>
                      <b-form-input
                        v-model="campiform.billing.note_xml"
                        placeholder=""
                      />
                  </b-col>
                  <b-col md="8" lg="3">
                    <label for="textarea-note">Rappresentante legale</label>
                      <b-form-input
                        v-model="campiform.billing.legal_representative"
                        placeholder=""
                      />
                  </b-col>
                </b-row>
              </b-card>
            </b-tab>
          </b-tabs>

          <b-row>
              <b-col md="12" class="text-center mb-3">
                <b-button
                  variant="outline-primary"
                  type="submit"
                  :disabled="action_press"
                  @click.prevent="validationForm()"
                >
                  <div v-if="action_press">Salvaggio in corso <b-spinner small class="ml-1" /></div>
                  <div v-else>Salva</div> 
                </b-button>
              </b-col>
          </b-row>
          
        </b-form>
      </validation-observer>        
    </div>      
  </div>
</template>

<script>
import router from '@/router'
import { ValidationProvider, ValidationObserver, localize } from 'vee-validate'
import it from 'vee-validate/dist/locale/it.json'
import { BTabs, BTab, BRow, BCol, BCard, BCardText, BSpinner, BButton, BFormGroup, BForm, BInputGroup, BFormInput, BFormTextarea, BInputGroupPrepend, BInputGroupAppend, BDropdownDivider, BFormSelect } from 'bootstrap-vue'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
import {
  required, email, digits, length, min
} from '@validations'
import { VueAutosuggest } from 'vue-autosuggest'
import Multiselect from 'vue-multiselect' 

export default {
  components: {
    ValidationProvider,
    ValidationObserver,
    it,
    BTabs,
    BTab,
    BRow,
    BCol,
    BCard, 
    BCardText, 
    BSpinner, 
    BButton, 
    BForm,
    BInputGroup,
    BFormGroup,
    BFormInput,
    BFormTextarea, 
    BInputGroupPrepend,
    BInputGroupAppend,
    BDropdownDivider,
    BFormSelect,

    VueAutosuggest, 
    Multiselect, 

    // eslint-disable-next-line vue/no-unused-components
    ToastificationContent, 
  },
  data() {
    return {
      id_italina: '114',
      valoreDefaultNazione: "",
      isReadOnly_fiscal_code: false, 
      isReadOnly_pec: false, 
      isReadOnly_dest_code: false, 
      lunghezza_campo_cap: 'required|digits:5',
      campiform: {
        customer: {
          id: '',
          user_id: '',
          reseller_id: '',
          assistant_id: '',
          hr_id: '',
          rating: '',
          created_at: '',
          source: {
            value: '',
            text: '',
          },
          lead_registered_at: '',
          converted_at: ''
        },
        user: {
          email: '', 
          name: '', 
          surname: '',
          mobile_phone: '',
          phone: '',
          website: '', 
          newsletter: '',
        },
        billing: {
          country_id: '',
          province_id: '',
          province_foreign: '',
          address: '',
          zip: '',
          city: '',
          company_name: '',
          vat_number: '',
          fiscal_code: '',
          pec: '',
          dest_code: '',
          vat_scheme_id: null,
          note_xml: '', 
          split_payment: '',
          legal_representative: ''
        },
        payment: { 
          list : [ ],
        }
      },
      required,
      email,
      digits,
      length,
      min,
      
      options_rating: [
        { value: 1, text: '1' },
        { value: 2, text: '2' },
        { value: 3, text: '3' },
        { value: 4, text: '4' },
        { value: 5, text: '5' },
      ],
      options_newsletter: [
        { value: 'Si', text: 'Si' },
        { value: 'No', text: 'No' },
        { value: 'Bounce', text: 'Bounce', disabled: true }
      ],
      options_split_payment: [
        { value: 'Si', text: 'Si' },
        { value: 'No', text: 'No' },
      ],
      options_usercrm_reseller: [ ],
      options_usercrm_assistente: [ ],
      options_evalution: [ ],
      options_source: [ ], 
      options_payment: [ ], 
      options: [ ],
      options_province: [ ],
      options_regine_iva: [ ],
      options_status: [ ], 
      Caricato: false,
      errore_caricamento: false,
      action_press: false,

      filteredOptions: [],
      limit: 10,
    }
  },
  created() {
    //errori validazione in italiano
    localize({
      it: {
        messages: it.messages,
      },
    })

    const countryPromise = this.$http.get('api/fs/country/list')
    const provincePromise = this.$http.get('api/fs/province/list')
    const userCrmAssistentiPromise = this.$http.get('api/crm/user/list?columnFilters={"role.type":"employee", "role.name":"assistant" }&page=1&perPage=100&status=active')
    const userCrmResellerPromise = this.$http.get('api/crm/user/list?columnFilters={"role.type":"employee", "role.name":"reseller" }&page=1&perPage=100&status=active')
    const evaluationPromise = this.$http.get('api/fs/customer/evaluation/list')
    const vatSchemePromise = this.$http.get('api/fs/employee/vat-scheme/list')
    const infoCustomerPromise = this.$http.get('api/crm/customer/card/'+router.currentRoute.params.id_riga)
    const infoBillingPromise = this.$http.get('api/crm/billing/customer/card/'+router.currentRoute.params.id_riga)
    const sourcePromise = this.$http.get('api/fs/lead/source/list')
    const paymentPromise = this.$http.get('api/fs/customer/payment/list')
    const listStatus = this.$http.get('api/fs/customer/status/list')

    Promise.all([countryPromise, provincePromise, userCrmAssistentiPromise, userCrmResellerPromise, evaluationPromise, vatSchemePromise, infoCustomerPromise, infoBillingPromise, sourcePromise, paymentPromise,listStatus]).then(response => {
      if(response[0].data.statusCode===200){
        //caricamento lista nazioni
        this.options = response[0].data.reply

        if(response[1].data.statusCode===200){
          //caricamento lista province italiane
          this.options_province = response[1].data.reply

          if(response[2].data.statusCode===200){
            //caricamento lista "assistent"
            let i = 0;
            while (i < response[2].data.reply.meta.total) {
              this.options_usercrm_assistente[i] = { value: response[2].data.reply.data[i].id, text: response[2].data.reply.data[i].name+' '+response[2].data.reply.data[i].surname },
              
              i++;
            }

            if(response[3].data.statusCode===200){
              //caricamento lista "reseller"
              let i = 0;
              while (i < response[3].data.reply.meta.total) {
                this.options_usercrm_reseller[i] = { value: response[3].data.reply.data[i].id, text: response[3].data.reply.data[i].name+' '+response[3].data.reply.data[i].surname },
                
                i++;
              }

              if(response[4].data.statusCode===200){
                //caricamento lista evalutation
                this.options_evalution = response[4].data.reply

                if(response[5].data.statusCode===200){
                  //caricamento lista regime iva
                  this.options_regine_iva = response[5].data.reply  
                  
                  if(response[6].data.statusCode===200){
                      //dati customer
                      this.campiform.customer = response[6].data.reply.customerData

                      console.log(this.campiform.customer)

                      //caricamento dati billing
                      this.campiform.billing = response[7].data.reply.billingData

                      //valore default per campo Nazione con autosuggest
                      var id_nazione = this.campiform.billing.country_id
                      var nazione = this.options.filter(function(elem){
                          if(elem.value == id_nazione){
                          return elem.text
                          }
                      })
                      this.valoreDefaultNazione = nazione[0].text

                      if(id_nazione != 114){
                        //stato estero
                        this.isReadOnly_fiscal_code = true;
                        this.isReadOnly_dest_code = true;
                        this.isReadOnly_pec = true;
                        this.lunghezza_campo_cap = 'required|min:2';
                      } else {
                        this.isReadOnly_fiscal_code = false;
                        this.isReadOnly_dest_code = false;
                        this.isReadOnly_pec = false;
                        this.lunghezza_campo_cap = 'required|digits:5';
                      }

                      //caricamento dati source lead
                      this.options_source = response[8].data.reply

                      this.campiform.payment.list = response[6].data.reply.customerData.payment.map(item => {
                        return {
                          value: item.id,
                          text: item.name
                        };
                      });

                      if(response[9].data.statusCode===200){
                        this.options_payment = response[9].data.reply

                        if(response[10].data.statusCode===200){

                          //caricamento lista Status
                          this.options_status = response[10].data.reply

                          //estrazione dati User (sicrono)
                          this.$http.get('api/crm/user/customer/card/'+this.campiform.customer.id).then(response_user => {
                            if((response_user.data.statusCode>=200) && (response_user.data.statusCode<=299)){
                              //risposta positiva
                              this.campiform.user = response_user.data.reply.userData
                              
                              this.Caricato = true;
                              this.errore_caricamento = false;
                            } else {
                              //risposta negativa (errore sul server)
                              
                              this.Caricato = false;
                              this.errore_caricamento = true;
                            }
                          }).catch(e => {
                            console.log(e);
                          });

                        } else {
                          this.Caricato = false;
                          this.errore_caricamento = true;
                        } 

                      } else {
                        this.Caricato = false;
                        this.errore_caricamento = true;
                      }
                  } else {
                  this.Caricato = false;
                  this.errore_caricamento = true;
                  }
                } else {
                this.Caricato = false;
                this.errore_caricamento = true;
                }
              } else {
              this.Caricato = false;
              this.errore_caricamento = true;
              }
              
            } else {
              this.Caricato = false;
              this.errore_caricamento = true;
            }
          } else {
            this.Caricato = false;
            this.errore_caricamento = true;
          }
        } else {
          this.Caricato = false;
          this.errore_caricamento = true;
        }
      } else {
        this.Caricato = false;
        this.errore_caricamento = true;
      }
    })
    
  },
  methods: {
    onInputChange(testo_ricerca) {
      if (testo_ricerca === '' || testo_ricerca === undefined) {
        return
      }

      /* filtra array nazioni - con filtro ricerca "stringa in qualsiasi posizizione" */
      //const filteredData = this.options.filter(item => item.text.toLowerCase().indexOf(testo_ricerca.toLowerCase()) > -1).slice(0, this.limit)
      
      /* filtra array nazioni - con filtro ricerca "stringa in posizizione iniziale" */
      const filteredData = this.options.filter(item => item.text.toLowerCase().indexOf(testo_ricerca.toLowerCase()) == 0).slice(0, this.limit)
      
      //console.log("filteredData ----------- per -> "+testo_ricerca)
      //console.log(filteredData)
      
      this.filteredOptions = [{
        data: filteredData,
      }]
    },
    renderSuggestion(suggestion) {
      //per gestire le voci restituite nella finestra auto-suggest
      //console.log("renderSuggestion")
      //console.dir(suggestion)
      return suggestion.item.text;
    },
    getSuggestionValue(suggestion) {
      //per gestire il testo che verra visualizzato dopo la selezione dela voce dalla finestra dell'auto-suggest
      //console.log("getSuggestionValue")
      //console.dir(suggestion)

      return suggestion.item.text;
    },
    selectHandler(text){
      if (text === '' || text === undefined) {
        return
      } else {
        //associo id_nazione al parametro da passare all'api
        this.campiform.billing.country_id = text.item.value
        //console.log(this.campiform.billing)

        if(this.campiform.billing.country_id == this.id_italina){
          //forzo campo "province_id"
          this.campiform.billing.province_id = '0';
          //Codice fiscale
          this.isReadOnly_fiscal_code = false;
          //codice SDI
          this.isReadOnly_dest_code = false;
          //Pec
          this.isReadOnly_pec = false;
          //lunghezza CAP (per validazione)
          this.lunghezza_campo_cap = 'required|digits:5';
        } else {
          //province_id estera
          this.campiform.billing.province_id = '112';
          //Codice fiscale
          this.isReadOnly_fiscal_code = true;
          this.campiform.billing.fiscal_code = ' '; //svuoto per sicurezza il campo
          //codice SDI
          this.campiform.billing.dest_code = '0000000';
          this.isReadOnly_dest_code = true;
          //Regime IVA
          this.campiform.billing.vat_scheme_id = '2'; //non soggetto
          //Pec
          this.isReadOnly_pec = true;
          this.campiform.billing.pec = ' '; //svuoto per sicurezza il campo
          //lunghezza CAP (per validazione)
          this.lunghezza_campo_cap = 'required|min:2';
        }
      }
    },
    multiSelect_act_Lingua ({ value, text }) {
      return `${text}`
    },
    validationForm() {
      this.$refs.simpleRules.validate().then(success => {
        if (success) {
          //console.log(this.campiform)
          this.action_press = true

          this.$http.post('api/crm/customer/card/'+this.campiform.customer.id, 
            this.campiform.customer 
            ).then(response => { 
              if((response.data.statusCode>=200) && (response.data.statusCode<=299)){
                //risposta positiva
                if(response.data.reply.customerData.id > 0){             
                  //OK -> procedo al salvataggio dati "billing"
                  this.$http.post('api/crm/billing/customer/card/'+response.data.reply.customerData.id , 
                  this.campiform.billing
                  ).then(response_billing => {
                    if((response_billing.data.statusCode>=200) && (response_billing.data.statusCode<=299)){
                      //risposta positiva
                      if(response_billing.data.reply.billingData.company_name != ''){             
                        //OK -> procedo al salvataggio dati "user"
                        this.$http.post('api/crm/user/customer/card/'+this.campiform.customer.id , 
                        this.campiform.user
                        ).then(response_user => {
                          if((response_user.data.statusCode>=200) && (response_user.data.statusCode<=299)){
                            //risposta positiva
                            //OK -> procedo alla sincronizzazione dei dati dell'anagrafica appena modificata su FIC

                            this.$http.post('api/crm/customer/sync_fic/'+this.campiform.customer.id)
                            .then(response_sync => {
                              if((response_sync.data.statusCode>=200) && (response_sync.data.statusCode<=299)){
                                //risposta positiva
                                
                                //ok -> procedo al salvataggio dei valori del Payment
                                this.$http.post('api/crm/customer/savepaymentsedit/'+this.campiform.customer.id, 
                                    this.campiform.payment
                                  ).then(response_payment => {
                                    if((response_payment.data.statusCode>=200) && (response_payment.data.statusCode<=299)){
                                      //risposta positiva
                                      this.$router.replace('/crm/customers')
                                        .then(() => {
                                          this.$swal({
                                              icon: 'success',
                                              title: 'Cliente aggiornato correttamente',
                                              confirmButtonText: 'chiudi',
                                              customClass: {
                                              confirmButton: 'btn btn-success',
                                              },
                                          })
                                        })
                                    
                                    } else {
                                      //risposta negativa (errore sul server)
                                      this.$swal({
                                          icon: 'error',
                                          title: 'Si è verificato un errore in Lead_Payments',
                                          text: 'Errore: A03 - '+response_payment.data.reply.message,
                                          customClass: {
                                          confirmButton: 'btn btn-outline-primary',
                                          },
                                      })

                                      this.action_press = false
                                    }
                                  }).catch(e => {
                                    console.log(e);
                                  });
                              
                              } else {
                                //risposta negativa (errore sul server)
                                this.$swal({
                                    icon: 'error',
                                    title: 'Si è verificato un errore nella sincronizzazione dai dati su Fatture in Cloud',
                                    text: 'operazione non riuscita, ti preghiamo di contattate l\'assistenza tecnica per segnalare il problema',
                                    customClass: {
                                    confirmButton: 'btn btn-outline-primary',
                                    },
                                })
                                  
                                this.action_press = false
                              }
                            }).catch(e => {
                              console.log(e);
                            });
                          
                          } else {
                            //risposta negativa (errore sul server)
                            this.$swal({
                                icon: 'error',
                                title: 'Si è verificato un errore nell\'aggiornamento utente',
                                text: 'operazione non riuscita, ti preghiamo di contattate l\'assistenza tecnica per segnalare il problema',
                                customClass: {
                                confirmButton: 'btn btn-outline-primary',
                                },
                            })
                              
                            this.action_press = false
                          }
                        }).catch(e => {
                          console.log(e);
                        });
                      } else {
                        //questo non dovrebbe mai accadere ... ma non si sa mai -> visualizzo risposta ma non faccio redirect
                        this.$swal({
                            icon: 'warning',
                            title: 'Si è verificato un errore sul Cliente',
                            text: 'Salvataggio riuscito ma con errore '+response.data.statusCode+', ti preghiamo di contattate l\'assistenza tecnica per segnalare il problema',
                            customClass: {
                            confirmButton: 'btn btn-outline-primary',
                            },
                        })
                              
                        this.action_press = false
                      }

                    
                    } else {
                      //risposta negativa (errore sul server)
                      this.$swal({
                          icon: 'error',
                          title: 'Si è verificato un errore in Billing',
                          text: 'operazione non riuscita, ti preghiamo di contattate l\'assistenza tecnica per segnalare il problema',
                          customClass: {
                          confirmButton: 'btn btn-outline-primary',
                          },
                      })
                        
                      this.action_press = false
                    }
                  }).catch(e => {
                    console.log(e);
                  });
                } else {
                  //questo non dovrebbe mai accadere ... ma non si sa mai -> visualizzo risposta ma non faccio redirect
                  this.$swal({
                      icon: 'warning',
                      title: 'Si è verificato un errore sul Cliente',
                      text: 'Salvataggio riuscito ma con errore '+response.data.statusCode+', ti preghiamo di contattate l\'assistenza tecnica per segnalare il problema',
                      customClass: {
                      confirmButton: 'btn btn-outline-primary',
                      },
                  })
                        
                  this.action_press = false
                }
                
              } else {
                //risposta negativa (errore sul server)
                if(response.data.reply.message != ''){
                  this.$swal({
                      icon: 'warning',
                      title: 'Si è verificato un errore',
                      text: response.data.reply.message,
                      customClass: {
                      confirmButton: 'btn btn-outline-primary',
                      },
                  })
                } else {
                  this.$swal({
                      icon: 'error',
                      title: 'Si è verificato un errore generico',
                      text: 'operazione non riuscita, ti preghiamo di contattate l\'assistenza tecnica per segnalare il problema',
                      customClass: {
                      confirmButton: 'btn btn-outline-primary',
                      },
                  })
                }

                this.action_press = false
              }
            }).catch(e => {
              console.log(e);
            });
          
        }
      })
    },

  },
}
</script>

<style lang="scss" >
@import '@core/scss/vue/libs/vue-sweetalert.scss';
@import '@core/scss/vue/libs/vue-autosuggest.scss';
@import '@core/scss/vue/libs/vue-multiselect.min.scss';
</style>
